import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const OrderViewContext = createContext();

export const OrderViewProvider = ({ children }) => {
  const [currentPage, setCurrentPage] = useState('');
  const [activeOrderId, setActiveOrderId] = useState(null);
  const [activeOrder, setActiveOrder] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState(new Set());
  const [orderStatus, setOrderStatus] = useState(null);

  const selectOrder = useCallback((id) => {
    setSelectedOrders((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedOrders(new Set());
  }, []);

  const value = useMemo(() => ({
    currentPage,
    setCurrentPage,
    activeOrderId,
    setActiveOrderId,
    activeOrder,
    setActiveOrder,
    selectedOrders,
    setSelectedOrders,
    selectOrder,
    clearSelection,
    orderStatus,
    setOrderStatus,
  }), [
    currentPage,
    activeOrderId,
    activeOrder,
    selectedOrders,
    setSelectedOrders,
    selectOrder,
    clearSelection,
    orderStatus,
    setOrderStatus,
  ]);

  return (
    <OrderViewContext.Provider value={value}>
      {children}
    </OrderViewContext.Provider>
  );
};

export const useOrderView = () => {
  const context = useContext(OrderViewContext);
  if (!context) {
    throw new Error('useOrderView must be used within an OrderViewProvider');
  }
  return context;
};

export default OrderViewContext;
